import React from 'react'
import { CustomerAuthContextGiaProvider } from './CustomerAuthContextGiaProvider'

export const CustomerAuthContextProviderWrapper = (
  props: React.PropsWithChildren<{}>
) => {
  return <CustomerAuthContextGiaProvider {...props} />
}
